function Timer() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <g id='ð¦ icon "timer"'>
        <path
          id="Vector"
          d="M9.24 18.48C7.98875 18.48 6.79164 18.2364 5.64867 17.7491C4.5057
            17.2618 3.52215 16.6061 2.69801 15.782C1.87387 14.9579 1.21816
            13.9743 0.730898 12.8313C0.243633 11.6884 0 10.4912 0 9.24C0 7.79625
            0.324844 6.41867 0.974531 5.10727L3.04992 6.13594C2.55664 7.1225 2.31 8.15719
            2.31 9.24C2.31 10.4912 2.6198 11.6493 3.23941 12.714C3.85902 13.7788 4.70121
            14.621 5.76598 15.2406C6.83074 15.8602 7.98875 16.17 9.24 16.17C10.4912 16.17
            11.6493 15.8602 12.714 15.2406C13.7788 14.621 14.621 13.7788 15.2406
            12.714C15.8602 11.6493 16.17 10.4912 16.17 9.24C16.17 7.77219 15.7519
            6.44875 14.9157 5.26969C14.0796 4.09062 12.9998 3.25445 11.6763
            2.76117L12.4884 0.595547C14.257 1.25727 15.6978 2.37617 16.8107
            3.95227C17.9236 5.52836 18.48 7.29094 18.48 9.24C18.48 10.4912
            18.2364 11.6884 17.7491 12.8313C17.2618 13.9743 16.6061 14.9579
            15.782 15.782C14.9579 16.6061 13.9743 17.2618 12.8313 17.7491C11.6884
            18.2364 10.4912 18.48 9.24 18.48ZM9.24 10.395C8.80687 10.395 8.47602
            10.2025 8.24742 9.8175C7.86242 9.40844 7.36312 8.84898 6.74953
            8.13914C6.13594 7.4293 5.45918 6.63824 4.71926 5.76598C3.97934
            4.89371 3.37176 4.12371 2.89652 3.45598C2.42129 2.78824 2.22879
            2.40926 2.31902 2.31902C2.40926 2.22879 2.78824 2.42129 3.45598
            2.89652C4.12371 3.37176 4.89371 3.97934 5.76598 4.71926C6.63824
            5.45918 7.4293 6.13895 8.13914 6.75855C8.84898 7.37816 9.40844
            7.87445 9.8175 8.24742C10.2025 8.47602 10.395 8.80687 10.395
            9.24C10.395 9.56484 10.2837 9.83855 10.0611 10.0611C9.83855
            10.2837 9.56484 10.395 9.24 10.395ZM9.24 2.31C8.91516 2.31
            8.64145 2.1957 8.41887 1.96711C8.19629 1.73852 8.085 1.4648
            8.085 1.14598C8.085 0.827148 8.19629 0.556445 8.41887
            0.333867C8.64145 0.111289 8.91215 0 9.23098 0C9.5498 0
            9.82352 0.111289 10.0521 0.333867C10.2807 0.556445 10.395
            0.830156 10.395 1.155C10.395 1.47984 10.2837 1.75355
            10.0611 1.97613C9.83855 2.19871 9.56484 2.31 9.24 2.31Z"
          fill="#EA5D5D"
        />
      </g>
    </svg>
  );
}

export default Timer;
